module.exports = __webpack_public_path__ + "static/media/fallOrange.c81e4762.jpg";